export default "__VITE_ASSET__KDpeOT6p__"